export default __webpack_public_path__ + "static/media/Nick.806b5919.svg";